import { useEffect, useState } from "react";
import { apiCall, fmtDate, euro, StateBadge } from "./rUtils";
import { InvoiceDialog } from "./InvoiceDialog";

const GROUPS = [["Offen", (r) => ["offen", "ueberfaellig", "ausgestellt"].includes(r.state)], ["Teilzahlungen", (r) => r.state === "teilweise"],
  ["Bezahlt", (r) => r.state === "bezahlt"], ["Stornos & Korrekturen", (r) => r.is_storno || ["storniert", "korrigiert", "erstattet"].includes(r.state)], ["Entwürfe", (r) => r.state === "entwurf"]];

export function CustomerInvoices({ token, email }) {
  const [list, setList] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [key, setKey] = useState(0);
  useEffect(() => { apiCall(token, `/rechnungen/admin/customer-invoices?email=${encodeURIComponent(email)}`).then((d) => setList(d.invoices)).catch(() => {}); }, [token, email, key]);
  return (
    <section data-testid="customer-invoices">
      <h4 className="font-['Bebas_Neue'] text-xl text-white">Rechnungen ({list.length})</h4>
      {!list.length && <p className="text-sm text-[#71717A]">Keine Rechnungen vorhanden.</p>}
      {GROUPS.map(([label, fn]) => {
        const items = list.filter(fn);
        return items.length ? (
          <div key={label} className="mt-2">
            <p className="text-xs uppercase tracking-widest text-[#71717A] mb-1">{label}</p>
            {items.map((r) => (
              <button key={r.invoice_id} type="button" onClick={() => setOpenId(r.invoice_id)} className="w-full text-left flex flex-wrap items-center gap-3 text-sm bg-[#1A1A1A] border border-white/5 hover:border-[#c1ff72]/40 p-2 mb-1" data-testid={`customer-invoice-${r.invoice_id}`}>
                <span className="text-white w-24">{r.invoice_number || "Entwurf"}</span><span className="text-[#A1A1AA] w-24">{fmtDate(r.invoice_date)}</span>
                <span className="flex-1 truncate text-[#A1A1AA]">{r.service}</span><span>{euro(r.total)}</span><StateBadge state={r.state} />
              </button>
            ))}
          </div>
        ) : null;
      })}
      {openId && <InvoiceDialog token={token} invoiceId={openId} onClose={() => setOpenId(null)} onChanged={() => setKey((k) => k + 1)} onOpen={setOpenId} />}
    </section>
  );
}
